import { ref } from 'vue';

const bus = ref(new Map<string, Function[]>());

export default function useEventsBus() {
  function gEmit(event: string, ...args: any[]): Promise<any> {
    return new Promise((resolve) => {
      if (bus.value.has(event)) {
        // Panggil semua callback yang terdaftar pada event ini
        bus.value.get(event)?.forEach((callback) => callback(...args, resolve));
      }
    });
  }

  function gOn(event: string, callback: Function) {
    if (!bus.value.has(event)) {
      bus.value.set(event, []);
    }
    bus.value.get(event)?.push(callback);
  }

  function gOff(event: string, callback: Function) {
    if (bus.value.has(event)) {
      bus.value.set(
        event,
        bus.value.get(event)?.filter((cb) => cb !== callback) || []
      );
    }
  }

  return {
    gEmit,
    gOn,
    gOff,
  };
}
